<template>
  <div class="inspectionIncomingDetailEdit">
    <el-dialog
        :visible.sync="dialogVisible"
        append-to-body
        :title="inspectionReport.pkid > 0 ? '质量检验编辑':'质量检验新建'"
        class="customer-edit"
        width="1400px"
        top="10vh"
        @close="$reset('form')">
      <el-form
          ref="form"
          v-loading="contentLoading"
          style="position: relative"
          :model="inspectionReport"
          :rules="ruleValidate"
          class="form"
          label-width="120px">
        <el-form-item label="检验项目">
          <el-checkbox-group v-model="inspectionReport.inspectionDetailVOS" @change="projectTypeChange">
            <el-checkbox v-for="item in inspectionReport.inspectionTemplateDetailVOS" :key="item.pkid" :label="item.inspectionName">{{item.inspectionName}}</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <div>
          <div style="border-bottom:1px solid #ddd;margin-bottom: 10px;padding-bottom: 5px;font-size: 16px;margin-top: 20px">检验附件</div>
          <div style="display: flex;flex-direction: row;align-items: center;justify-content: space-between;margin: 10px 0 10px 0">
            <upload-file
                ref="upload"
                :auth-index="authIndex"
                style="margin-bottom: 10px; float: left"
                @upload-success="uploadSuccess"/>
          </div>
          <el-table
              v-if="inspectionReport.accessoryList"
              ref="payData1"
              :data="inspectionReport.accessoryList">
            <el-table-column type="index" align="center" label="行号"/>
            <el-table-column prop="fileName" align="center" label="图片">
              <template slot-scope="scope">
                <el-image
                    style="width: 50px; height: 50px;margin-right: 10px"
                    :src="scope.row.imgUrl"
                    :preview-src-list="imgUrls"/>
              </template>
            </el-table-column>
            <el-table-column prop="fileName" align="center" label="附件描述">
              <template slot-scope="scope">
                <el-input v-model="scope.row.fileName" class="tabInput" style="width: 400px;margin: 0 auto;text-align: center"/>
              </template>
            </el-table-column>
            <el-table-column label="操作" align="center" width="60" class-name="vm-table_operate">
              <template slot-scope="scope">
                <el-button type="danger" @click="fileDelete(scope.row,scope.$index)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-form>
      <span slot="footer">
        <el-button type="info" @click="dialogVisible=false">关闭</el-button>
        <el-button type="primary" @click="reportSave()">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import constant from "../../../util/constant";
  import constants from "../../../util/constants";
  import loginUtil from "@/util/loginUtil";
  import UploadFile from "@/components/UploadFile";

  export default {
    name: "InspectionIncomingDetailEdit1",
    components: {UploadFile},
    data() {
      return {
        constant,
        constants,
        authIndex: 39,
        imgUrls: [],
        uploadLoading: false,
        billId: "0",
        billType: "23",
        index: 0,
        handleType: constant.toSelect(constant.handleType),
        exportLoading: false,
        dialogVisible: false,
        contentLoading: false,
        submitLoading: false,
        saveLoading: false,
        activeName: "first",
        barCode: "",
        value: "",
        inspectionReport: {
          pkid: 0,
          barCode: "",
          voucherNo: "",
          no: "",
          billID: "",
          billType: "",
          inspectionType: 10,
          storageInspectionType: 30,
          conclusion: 0,
          inspectionResult: false,
          needHandle: true,
          handleType: 10,
          materialNo: "",
          materialName: "",
          handleDepartment: "",
          standards: "",
          practical: "",
          problemClassification: "",
          badQuality: "",
          preliminaryInvestigation: "",
          responsibleDepartment: "",
          responsibleID: "",
          responsibleName: "",
          supplierID: "",
          supplierName: "",
          regionalID: "",
          regionalManager: "",
          handleID: "",
          handleName: "",
          qualitativeClassification: "",
          createdTime: "",
          inspectorName: "",
          accessories: [],
          inspectionMaterials: [],
          accessoryList: [],
          countersignVOS: [],
          inspectionTemplateDetailVOS: [],
          inspectionDetailVOS: ["A:包装","B:标识","C:外观","D:规格型号"],
          rawMaterialInspections: [],

        },
        ruleValidate: {
          regionalManager: {required: true, message: "不能为空", trigger: "blur"},
        },
      };
    },
    methods: {
      open(row,index) {
        this.inspectionReport.pkid = row.pkid;
        this.index = index;
        this.billId = row.pkid + "";
        this.barCode = row.barcode;
        this.dialogVisible = true;
        console.log(this.inspectionReport.pkid);
        if (this.inspectionReport.pkid > 0) {
          this.getData();
        }else {
          this.inspectionReport = row;
        }
      },
      fileDelete(row,index) {
        this.inspectionReport.accessoryList.splice(index, 1);
      },
      uploadSuccess(fileList) {
        if (fileList.length) {
          const params = {
            fileName: fileList[0].name,
            filePath: fileList[0].key,
            imgUrl: "",
          };
          this.$http.get("basic", `files/getDownloadUrl?key=${params.filePath}`).then((res) => {
            if (res.success) {
              params.imgUrl = res.data;
              this.imgUrls.push(params.imgUrl);
            }
          });
          this.inspectionReport.accessoryList.push(params);
        }
      },
      getData() {
        this.contentLoading = true;
        this.$http
          .get("basic", `inspectionReports/selectReportByPKID/${this.inspectionReport.pkid}`)
          .then(resp => {
            console.log(resp);
            this.inspectionReport = resp.data;
            this.inspectionReport.accessoryList.forEach(row => {
              this.$http.get("basic", `files/getDownloadUrl?key=${row.filePath}`).then((res) => {
                if (res.success) {
                  row.imgUrl = res.data;
                  this.imgUrls.push(row.imgUrl);
                }
              });
            });

            this.contentLoading = false;
          });
      },
      projectTypeChange(value) {
        let id = this.inspectionReport.pkid;
        if (this.inspectionReport.pkid===0) {
          return this.$message.error("请先保存！！！");
        }
        if (value.toString().includes("G:尺寸") || value.toString().includes("H:性能")) {
          let routeData = this.$router.resolve({path: "/printRMIR/" +  id});
          window.open(routeData.href, "_blank");
          // this.$router.push({
          //   path: "/printRMIR",
          //   query: {
          //     id: id,
          //     inspectionReport: this.inspectionReport,
          //   },
          // });
        }
      },
      submitUpload(params) {
        this.uploadLoading = true;
        let formData = new FormData(); //  用FormData存放上传文件
        formData.append("files", params.file);
        formData.append("Authorization", loginUtil.getToken());
        this.$http
          .post("basic", "file/batch/0", formData)
          .then((res) => {
            this.uploadLoading = false;
            // this.saveAttachments(res.data.attachments, 0);
            const fileInfo = res.data.attachments[0];
            console.log(fileInfo);
            this.inspectionReport.accessoryList.push({
              fileName: fileInfo.fileName,
              filePath: "/attached/file/" + fileInfo.filePath,
              note: "",
            });
            this.$message.success("上传成功");
          })
          .catch(() => {
            this.uploadLoading = false;
            this.$message.error("上传失败");
          });
      },
      deleteFile(index) {
        this.inspectionReport.accessoryList.splice(index, 1);
      },
      openFile(item) {
        console.log(item);
        let a = document.createElement("a");
        a.href = "http://emes.stepelectric.com" + item.filePath;
        a.target = "_blank";
        a.download = item.filePath;
        a.style.display = "none";
        document.body.appendChild(a);
        a.click();
        URL.revokeObjectURL(a.href);
        document.body.removeChild(a);
      },
      getFormatDate(date) {
        let month = date.getMonth() + 1;
        let strDate = date.getDate();
        let hours = date.getHours();
        let minutes = date.getMinutes();
        let seconds = date.getSeconds();
        if (month >= 1 && month <= 9) {
          month = "0" + month;
        }
        if (strDate >= 0 && strDate <= 9) {
          strDate = "0" + strDate;
        }
        if (hours >= 0 && hours <= 9) {
          hours = "0" + hours;
        }
        if (minutes >= 0 && minutes <= 9) {
          minutes = "0" + minutes;
        }
        if (seconds >= 0 && seconds <= 9) {
          seconds = "0" + seconds;
        }
        return date.getFullYear() + "-" + month + "-" + strDate + " " + hours + ":" + minutes + ":" + seconds;
      },
      onSelectHandle(row) {
        console.log(row);
        this.inspectionReport.handleID = row.systemUserID;
        this.inspectionReport.handleName = row.employeeName;
      },
      onSelectResponsibleName(row) {
        console.log(row);
        this.inspectionReport.responsibleID = row.systemUserID;
        this.inspectionReport.responsibleName = row.employeeName;
        this.inspectionReport.responsibleDepartment = row.departmentName;
      },
      selectRegionalManager(row) {
        console.log(row);
        this.inspectionReport.regionalID = row.systemUserID;
        this.inspectionReport.regionalManager = row.employeeName;
      },
      onSelectCountersign(row) {
        this.inspectionReport.countersignID = row.systemUserID;
        this.inspectionReport.countersignName = row.employeeName;
      },
      onSelectRework(row) {
        this.inspectionReport.reworkID = row.systemUserID;
        this.inspectionReport.reworkName = row.employeeName;
      },
      onSelectSupplier(row) {
        this.inspectionReport.supplierID = row.pkid;
        this.inspectionReport.supplierName = row.name;
      },
      downloadExcel(row) {
        console.log(row.filePath);
        let a = document.createElement("a");
        a.href = row.filePath;
        a.download = row.accessoryName;
        a.style.display = "none";
        document.body.appendChild(a);
        a.click();
        URL.revokeObjectURL(a.href);
        document.body.removeChild(a);
      },
      selectNameByNo() {
        if (this.inspectionReport.materialNo.length > 0) {
          let params = {
            no: this.inspectionReport.materialNo,
          };
          this.$http
            .get("basic", "baseMaterials/selectNameByNo", params)
            .then((res) => {
              this.inspectionReport.materialName = res;
              console.log(res);
            });
        }

      },
      reportSave() {
        this.$emit("save-success1", this.inspectionReport,this.index);
        this.dialogVisible = false;
      },
    },
  };
</script>

<style lang="scss">
  .inspectionIncomingDetailEdit {
    .table {
      width: 100%;
      margin: 2% auto;
      border-top: 1px solid #dddddd;
      border-left: 1px solid #dddddd;

      .tableLabel {
        width: 130px;
        padding: 1%;
        background: #f4f7fa;
        border-bottom: 1px solid #dddddd;
      }

      .tableModel {
        width: 20%;
        padding: 1%;
        border-left: 1px solid #dddddd;
        border-right: 1px solid #dddddd;
        border-bottom: 1px solid #dddddd;
      }
    }
  }

</style>
